import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import colors from 'theme/colors';

const getIconColor = (props) => {
    switch (props.color) {
        case 'darkGray':
            return props.useThemeColor ? props.theme.black : colors.baseColor;
        case 'mediumGray':
            return props.useThemeColor ? props.theme.grey_72_lc : colors.mediumGray;
        case 'lightGray':
            return props.useThemeColor ? props.theme.grey_40_lc : colors.lightGray;
        case 'superLightGray':
            return props.useThemeColor ? props.theme.grey_8_lc : colors.superLightGray;
        case 'greyRgba28':
            return props.useThemeColor ? props.theme.grey_28_tr : colors.greyRgba28;
        case 'purple':
            return props.useThemeColor ? props.theme.purple_100 : colors.purple;
        case 'purpleRgba24':
            return props.useThemeColor ? props.theme.purple_24_tr : colors.purpleRgba24;
        case 'purpleRgba40':
            return props.useThemeColor ? props.theme.purple_40_tr : colors.purpleRgba40;
        case 'red':
            return props.useThemeColor ? props.theme.pink_100 : colors.red;
        case 'white':
            return props.useThemeColor ? props.theme.white : colors.white;
        case 'whiteRgba64':
            return props.useThemeColor ? props.theme.white_72_tr_base : colors.whiteRgba64;
        default:
            return props.useThemeColor ? props.theme.black : colors.baseColor;
    }
};

const defaultSize = '24px';

const Container = styled.span`
    display: inline-block;
    height: ${(props) => (props.size ? props.size : defaultSize)};
    margin-right: ${(props) => (props.rightIndent ? props.rightIndent : null)};
    margin-left: ${(props) => (props.leftIndent ? props.leftIndent : null)};

    svg {
        width: ${(props) => (props.size ? props.size : defaultSize)};
        height: ${(props) => (props.size ? props.size : defaultSize)};
        --accent: ${(props) => getIconColor(props)};
    }
`;

function renderSVG({ id }) {
    return (
        <svg>
            <use xlinkHref={`/i/promo-svg-icons/promo-icons.svg#${id}`} />
        </svg>
    );
}

const StyledSVGIcon = styled(renderSVG)`
    display: inline-block;
`;

export const LightIcon = (props) => {
    return (
        <Container rightIndent={props.rightIndent} leftIndent={props.leftIndent} color={props.color} size={props.size} useThemeColor={props.useThemeColor}>
            <StyledSVGIcon id={props.name} />
        </Container>
    );
};

LightIcon.propTypes = {
    name: PropTypes.string,
    color: PropTypes.oneOf([
        'darkGray',
        'mediumGray',
        'lightGray',
        'superLightGray',
        'greyRgba28',
        'purple',
        'purpleRgba24',
        'purpleRgba40',
        'red',
        'white',
        'whiteRgba64',
    ]),
    size: PropTypes.oneOf(['16px', '20px', '24px', '32px', '48px', '56px', '64px', '80px', '96px', '100%']),
    rightIndent: PropTypes.oneOf(['4px', '8px', '12px', '16px', '24px', '32px']),
    leftIndent: PropTypes.oneOf(['4px', '8px', '12px', '16px', '24px', '32px']),
    useThemeColor: PropTypes.bool,
};
